/* eslint-disable no-underscore-dangle */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { getLeftCheckedMailProcessingCenters, getRightCheckedMailProcessingCenters } from '../../../../common/user/redux/selectors/UserDataSelectors';
import { getAssetType } from '../../../../common/asset-types/redux/selectors/AssetTypesSelectors';
import { tableLoadData } from '../../../../common/tables/actions/ListTableActions';
import TableDefinitions from '../../../../common/TableDefinitions';
import ListTable from '../../../../common/tables/ListTable';
import {
  getColumns,
  getData,
  getTotalColumns,
  getTotalData,
  getIsLoading,
  getTotalFilteredData,
  getFilteredData,
} from '../redux/selectors/FluxVolumeOeReportSelectors';
import FluxVolumeOeReportSelectionCriteriaContainer from './FluxVolumeOeReportSelectionCriteriaContainer';
import downloadTypes from '../../../../common/tables/excel/DownloadTypes';
import { setGlobalEndDateSelectionActionCreator, setGlobalStartDateSelectionActionCreator } from '../../../../common/selection-criteria/period/redux/actions/GlobalPeriodSelectionActions';
import { getGlobalEndDate, getGlobalStartDate } from '../../../../common/selection-criteria/period/redux/selectors/GlobalPeriodSelectionSelectors';

const leftTree = {
  title: 'Focal Operators and IMPCs',
  roleFilter: true,
};
const rightTree = {
  title: 'Operators and IMPCs',
  roleFilter: false,
};

class FluxVolumeOeReportContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showResult: false,
      selectedStartDate: this.props.globalStartDate,
      selectedEndDate: this.props.globalEndDate,
    };
  }

  onStartDateChange = (newDate) => {
    this.setState({
      selectedStartDate: newDate,
    });
    this.props.setGlobalStartDateSelectionActionCreator(newDate);
  }

  onEndDateChange = (newDate) => {
    this.setState({
      selectedEndDate: newDate,
    });
    this.props.setGlobalEndDateSelectionActionCreator(newDate);
  }

  onCriteriaApply = () => {
    this.setState({
      showResult: true,
    });

    this.props.tableLoadData(
      { tableId: 'REPORTING_FLUX_VOLUME_OE' },
      this.props.appContext.appContext,
      {
        endDate: this.state.selectedEndDate,
        focals: this.props.leftCheckedMailProcessingCenters,
        startDate: this.state.selectedStartDate,
        targets: this.props.rightCheckedMailProcessingCenters,
      },
    );
  };

  render() {
    const { showResult, selectedStartDate, selectedEndDate } = this.state;
    const {
      data,
      isLoading,
      columns,
      columnsTotal,
      dataTotal,
      filteredData,
      totalFilteredData,
    } = this.props;

    return (
      <div>
        <FluxVolumeOeReportSelectionCriteriaContainer
          open={data.length === 0}
          title="Flux & Volume OE Report"
          onApply={this.onCriteriaApply}
          selectedStartDate={selectedStartDate}
          onStartDateChange={this.onStartDateChange}
          selectedEndDate={selectedEndDate}
          onEndDateChange={this.onEndDateChange}
          leftTree={leftTree}
          rightTree={rightTree}
        />
        <div className="general-content-container" style={{ flexDirection: 'column' }}>
          {(showResult || data.length > 0) && (
            <div style={{ minHeight: '740px' }}>
              <div className="full-width">
                <div className="list-table-container" style={{ paddingBottom: '20px' }}>
                  <ListTable
                    listId={TableDefinitions.REPORTING_FLUX_VOLUME_OE.id}
                    loading={isLoading}
                    columns={columns}
                    data={data}
                    keyField="id"
                    selectCheckbox
                    pagination
                    downloadType={downloadTypes.EXCEL}
                  />
                </div>
              </div>
              <div className="full-width">
                <div className="list-table-container" style={{ paddingBottom: '20px' }}>
                  <ListTable
                    listId={TableDefinitions.REPORTING_FLUX_VOLUME_OE.id}
                    loading={isLoading}
                    columns={columnsTotal}
                    data={filteredData.length > 0 ? totalFilteredData : dataTotal}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

FluxVolumeOeReportContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  columns: PropTypes.arrayOf(PropTypes.object),
  dataTotal: PropTypes.arrayOf(PropTypes.object),
  totalFilteredData: PropTypes.arrayOf(PropTypes.object),
  filteredData: PropTypes.arrayOf(PropTypes.object),
  columnsTotal: PropTypes.arrayOf(PropTypes.object),
  appContext: PropTypes.objectOf(PropTypes.string),
  leftCheckedMailProcessingCenters: PropTypes.arrayOf(PropTypes.string),
  rightCheckedMailProcessingCenters: PropTypes.arrayOf(PropTypes.string),
  tableLoadData: PropTypes.func,
  isLoading: PropTypes.bool,
  globalStartDate: PropTypes.instanceOf(Date),
  globalEndDate: PropTypes.instanceOf(Date),
  setGlobalStartDateSelectionActionCreator: PropTypes.func,
  setGlobalEndDateSelectionActionCreator: PropTypes.func,
};

function mapStateToProps(state, props) {
  return {
    data: getData(state),
    columns: getColumns(state),
    dataTotal: getTotalData(state),
    columnsTotal: getTotalColumns(state, props),
    leftCheckedMailProcessingCenters: getLeftCheckedMailProcessingCenters(state),
    rightCheckedMailProcessingCenters: getRightCheckedMailProcessingCenters(state),
    appContext: getAssetType(state),
    isLoading: getIsLoading(state),
    globalStartDate: getGlobalStartDate(state),
    globalEndDate: getGlobalEndDate(state),
    totalFilteredData: getTotalFilteredData(state),
    filteredData: getFilteredData(state),
  };
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  tableLoadData,
  setGlobalStartDateSelectionActionCreator,
  setGlobalEndDateSelectionActionCreator,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(FluxVolumeOeReportContainer);
